import "~/scss/pages/chair_index_page.scss";

$(() => {
    $(".research-axis-title").each((_, element) => {
        const domElement = $(element)[0];
        const triggerDomElement = $(element).parent().find(".sticky-trigger")[0];
        let observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    $(domElement).addClass("sticky-active"); // Remove background when normal
                } else {
                    $(domElement).removeClass("sticky-active"); // Add background when sticky
                }
            },
            { threshold: 0 }
        );
    
        observer.observe(triggerDomElement);
    });
});